<!-- footer start-->
<div class="container-fluid">
  <div class="row">
    <div div class="col-md-12 footer-copyright text-center" style="text-transform: lowercase;
    ">
      <!-- <p class="mb-0"> Collaborate 2022 All Rights Reserved, Developed & Powered by wecancity.com © </p> -->
    <p class="mb-0">  © afdhal sadaka dashboard {{year}} All Rights Reserved 
     </p>
   
    </div>
  </div>
</div>

 